<template>
    <div class="list-product-card">
        <div class="list-product-card-inner">
            <div class="product-card-left position-relative">
                <a :href="productUrl" class="product-image">
                    <img
                        :src="baseImage"
                        :class="{ 'image-placeholder': !hasBaseImage }"
                        :alt="product.name"
                    />
                </a>

                <ul class="list-inline product-badge" v-if="category == 'shop'">
                    <li class="badge badge-danger" v-if="item.is_out_of_stock">
                        {{ $trans("storefront::product_card.out_of_stock") }}
                    </li>

                    <li class="badge badge-primary" v-else-if="product.is_new">
                        {{ $trans("storefront::product_card.new") }}
                    </li>
                    <li class="badge badge-primary" v-else-if="product.is_preorder">
                        {{ $trans("storefront::product_card.pre_order") }}
                    </li>

                    <li
                        class="badge badge-success"
                        v-if="item.has_percentage_special_price"
                    >
                        -{{ item.special_price_percent }}%
                    </li>
                </ul>
            </div>

            <div class="product-card-right" v-if="category == 'preorder'">
                <a :href="productUrl" class="product-name">
                    <h6>{{ product.name }}</h6>
                </a>
                <div class="clearfix"></div>
                <div class="product-price fz-13" v-html="item.preorder_price"></div>

                <button class="btn btn-default btn-add-to-cart"
                    :class="{ 'btn-loading': addingToCart }"
                    @click="addToPreorder"
                >
                    <i class="las la-rupee-sign"></i>
                    Pre Order
                </button>
            </div>
            
        </div>
    </div>
</template>

<script>
import ProductCardMixin from "../../../mixins/ProductCardMixin";

export default {
    mixins: [ProductCardMixin],

    props: ["product", 'category'],

    computed: {
        item() {
            return {
                ...(this.product.variant ? this.product.variant : this.product),
            };
        },
    },
};
</script>
